//////////////////////
// import
//////////////////////

import BezierEasing from 'bezier-easing';
import {TweenMax} from 'gsap/TweenMax';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
import './animation.js';
import './googlelocator.js';
import Xt from 'xtend-library';
import Player from '@vimeo/player/dist/player.js';
import './swiper-bundle.min.js';

document.documentElement.classList.add('xt-focus--disable');

//////////////////////
// .banner-rotator
//////////////////////

(function(){
  const bannerRotator = function(main) {
    // vars

    const container = main
    if (container.closest('.xt-clone')) return
    const items = container.querySelectorAll('.banner-rotator-item')
    const time = parseFloat(container.getAttribute('data-time')) || 8000
    let i = 0

    // change

    const change = () => {
      let bannerHeight = 0
      for (const item of items) {
        item.classList.add('loaded')
        item.classList.remove('active')
        const height = item.querySelector('.banner-rotator-item-content').offsetHeight
        bannerHeight = height > bannerHeight ? height : bannerHeight
      }
      items[i].classList.add('active')
      container.style.height = bannerHeight + 'px'
      i++
      i = i >= items.length ? 0 : i
      // header
      if (container.classList.contains('banner-rotator-height')) {
        const header = document.querySelector('.header:not(.xt-clone) .header_inner')
        let headerHeight = 0
        if (header) {
          headerHeight = header.offsetHeight
        }
        // slides
        const slides = document.querySelectorAll('.slider--home_img')
        if (slides.length) {
          let slideheight = window.innerHeight - bannerHeight - headerHeight
          for (const slide of slides) {
            slide.style.height = slideheight + 'px'
          }
        }
      }
    }

    if (items.length > 1) {
      setInterval(change, time)
    }
    change()
  };

  for (const banner of document.querySelectorAll('.banner-rotator')) {
    bannerRotator(banner)
  }
})();

//////////////////////
// denim
//////////////////////

new Swiper('.blocks--denim-swiper', {
  slidesPerView: 'auto',
  slidesPerGroup: 2,
  centerInsufficientSlides: true,
  spaceBetween: 0,
  loop: false,
  navigation: {
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next',
  },
});

//////////////////////
// denim video autoplay
//////////////////////

Xt.observe.push({
  matches: '.blocks--denim_category_container',
  fnc: function (main, index, query) {
    // vars

    const element = main
    const video = element.querySelector('video')
    if (!video) return

    // onEnter

    const onEnter = () => {
      if (matchMedia('(hover: hover), not (pointer: coarse)').matches) {
        video.play()
      }
    }

    element.addEventListener('mouseenter', onEnter)

    // onLeave

    const onLeave = () => {
      if (matchMedia('(hover: hover), not (pointer: coarse)').matches) {
        video.pause()
      }
    }

    element.addEventListener('mouseleave', onLeave)

    // onResize

    const onResize = () => {
      if (matchMedia('(hover: none), (pointer: coarse)').matches) {
        video.play()
      }
    }

    addEventListener('resize', onResize)
    onResize()
  }
});

//////////////////////
// video matches
//////////////////////

Xt.observe.push({
  matches: 'video source[data-src]',
  fnc: function (main, index, query) {
    // vars

    const video = main.closest('video')

    // resize

    const resize = () => {
      const src = video.src
      let srcNew = false
      const sources = video.querySelectorAll('source[data-src]')
      for (const source of sources) {
        const media = source.getAttribute('media')
        if (media && matchMedia(media).matches) {
          srcNew = source.getAttribute('data-src')
        }
      }
      if (srcNew) {
        if (src.indexOf(srcNew) === -1) {
          video.src = srcNew
        }
      } else {
        const sourceDefault = video.querySelector('source[src]')
        if (sourceDefault) {
          const srcDefault = sourceDefault.getAttribute('src')
          if (srcDefault && src.indexOf(srcDefault) === -1) {
            video.src = srcDefault
          }
        }
      }
    }

    addEventListener('resize', resize)
    resize()
  }
});

//////////////////////
// slider--gallery video on activation
//////////////////////

Xt.observe.push({
  matches: 'video source[data-src]:not([src]), iframe[data-src]:not([src])',
  fnc: function (main, index, query) {
    // vars

    const element = main.closest('video') || main

    // visible

    const visible = () => {
      // iframe
      if (element.matches('iframe') && !main.getAttribute('src')) {
        element.setAttribute('src', src);
      }
      // video
      if (element.matches('video') && !element.src) {
        element.src = main.getAttribute('data-src');
      }
    }

    // IntersectionObserver

    const observer = new IntersectionObserver(
      (entries, observer) => {
        for (const entry of entries) {
          if (entry.intersectionRatio > 0) {
            visible()
            observer.disconnect()
          }
        }
      },
      { root: null }
    )
    observer.observe(element)
  }
});

//////////////////////
// product-item video on mouseenter
//////////////////////

const initializeVideo = function (main) {
  // vars

  const img = main.querySelector('.product-image-wrapper');
  const videoWrapper = main.querySelector('.product-video-wrapper');

  if (!img || !videoWrapper || !matchMedia('(min-width: 992px)').matches || matchMedia('(hover: none)').matches) { // if mobile don't do it
    return;
  }

  const mp4 = videoWrapper.querySelector('video');
  const iframe = videoWrapper.querySelector('iframe');

  if (!mp4 && !iframe) {
    return
  }

  // eventEnter

  const eventEnter = () => {
    videoWrapper.classList.add('active');
    if (mp4) {
      mp4.append(Xt.createElement('<source type="video/mp4" src="'+mp4.getAttribute('data-src')+'">'));
      mp4.play();
    } else if (iframe) {
      if (!iframe.getAttribute('src')) {
        iframe.setAttribute('src', iframe.getAttribute('data-src'));
      }
    }
  };

  main.addEventListener('mouseenter', eventEnter)

  // eventLeave

  const eventLeave = () => {
    videoWrapper.classList.remove('active');
    if (mp4) {
      mp4.pause();
    }
  };

  main.addEventListener('mouseleave', eventLeave);

  // eventLoaded

  if (iframe) {
    const eventLoaded = () => {
      videoWrapper.classList.add('loaded');
    };

    iframe.addEventListener('load', eventLoaded)
  }
}

Xt.observe.push({
  matches: '.product-item',
  fnc: function (main, index, query) {
    initializeVideo(main)
  }
});

//////////////////////
// open cart with hash
//////////////////////

Xt.observe.push({
  matches: '#overlay--minicart',
  fnc: function (main, index, query) {

    function locationHashChanged() {
      if (location.hash === '#cart') {
        requestAnimationFrame( function () {
          main.dispatchEvent(new CustomEvent('on.xt'));
        })
      }
    }
    window.onhashchange = locationHashChanged;
    locationHashChanged();

  }
});

//////////////////////
// open denim guide products with hash
//////////////////////

Xt.observe.push({
  matches: '[data-js-overlay-hash]',
  fnc: function (main, index, query) {
    // vars

    const hash = main.getAttribute('data-js-overlay-hash')

    // eventOn

    function eventOn() {
      location.hash = hash
    }

    main.addEventListener('on.xt', eventOn);

    // eventOff

    function eventOff() {
      location.hash = ''
    }

    main.addEventListener('off.xt', eventOff);

    // locationHashChanged

    function locationHashChanged() {
      if (location.hash.split('#')[1] === hash) {
        requestAnimationFrame( function () {
          main.dispatchEvent(new CustomEvent('on.xt'));
        })
      } else if (main.classList.contains('active')) {
        requestAnimationFrame( function () {
          main.dispatchEvent(new CustomEvent('off.xt'));
        })
      }
    }
    window.addEventListener("hashchange", locationHashChanged)
    window.addEventListener("popstate", locationHashChanged)
    locationHashChanged();
  }
});

//////////////////////
// open .portfolio-block with hash
//////////////////////

Xt.observe.push({
  matches: '.portfolio-block',
  fnc: function (main, index, query) {
    // vars

    let skipEvent = false;

    // locationHashLoad

    function locationHashLoad() {
      if (location.hash === main.getAttribute('href')) {
        requestAnimationFrame( function () {
          skipEvent = true;
          main.dispatchEvent(new CustomEvent('on.xt'));
          skipEvent = false;
        });
      }
    }
    locationHashLoad();

    // eventOn

    const eventOn = e => {
      if (skipEvent) return;
      setTimeout(() => {
        const target = document.querySelector(main.getAttribute('href'));
        if (target) {
          let iframes = target.querySelectorAll('iframe');
          iframes = Array.from(iframes).filter(x => x.offsetHeight > 0 || x.getClientRects().length > 0)
          if (iframes.length && Player) {
            var player = new Player(iframes[0]);
            player.play();
          }
        }
      }, 0)
    }

    main.addEventListener('on.xt', eventOn);

    // eventOn

    const eventOff = e => {
      const target = document.querySelector(main.getAttribute('href'));
      if (target) {
        let iframes = target.querySelectorAll('iframe');
        iframes = Array.from(iframes).filter(x => x.offsetHeight > 0 || x.getClientRects().length > 0)
        if (iframes.length && Player) {
          var player = new Player(iframes[0]);
          player.pause();
        }
      }
    }

    main.addEventListener('off.xt', eventOff);
  }
});

//////////////////////
// open newsletter with hash
//////////////////////

Xt.observe.push({
  matches: '#overlay--newsletter',
  fnc: function (main, index, query) {

    function locationHashChanged() {
      if (location.hash === '#newsletter') {
        requestAnimationFrame( function () {
          main.dispatchEvent(new CustomEvent('on.xt'));
        })
      }
    }
    window.onhashchange = locationHashChanged;
    locationHashChanged();

  }
});

//////////////////////
// xt-scroll
//////////////////////

// inject

let scrollDefaults = document.querySelectorAll('.block--default, .block--featured, .slider, .block_title, .product-item, .product-page_gray, .product-page_body, .lookbook-page_row, .breadcrumbs, .submenu_wrapper, .page-submenu > *, .account-access, body.account .column.main > *, .cms-page, .page-title-wrapper, .googlelocator')
for (let scrollDefault of scrollDefaults) {
  if (!scrollDefault.classList.contains('scroll--disable') && !document.querySelector('body').classList.contains('page-print')) {
    scrollDefault.classList.add('scroll--default');
  }
}

/*
let scrollsDefaults = document.querySelectorAll('')
for (let scrollsDefault of scrollsDefaults) {
  scrollsDefault.classList.add('scrolls--default');
}
*/

// activateScrolls after preload

window.activateScrolls = function () {
  // xt-scroll
  let self = Xt.get('xt-scroll', document.documentElement);
  if (self) {
    self.initStart();
  }
};

window.deactivateScrolls = function () {
  let fades = document.querySelectorAll('.scroll--default');
  for (let fade of fades) {
    fade.classList.remove('fade', 'scroll--once', 'scroll--visible');
    fade.classList.add('out', 'scroll--block');
  }
  // boxes
  let boxes = document.querySelectorAll('#notice-cookie-block, .shipping-switch, .backdrop--header');
  for (let box of boxes) {
    box.classList.add('out');
  }
};

// xt-scroll

Xt.observe.push({
  matches: 'html',
  fnc: function (main, index, query) {

    // scroll

    let self = Xt.init('xt-scroll', document.documentElement, {
      "class": "fade",
      "elements": ".scrolls--default > *, .scroll--default",
      "distance": 50,
      "delayOn": "return Math.min(current * 100, 600)",
      "delayOff": "return Math.min((total - current) * 100, 600)"
    });

  }
});

//////////////////////
// xtend extension: exitIntent
// needs: a UNIQUE window.onbeforeunload with inside // exit intent confirm
//////////////////////

/* USAGE:
window.onbeforeunload = function(e) {
  if (window.exitIntentActivated) {
    // exit intent confirm
    let result = confirm();
    if (!result){
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    return result;
  }
};
*/

/*
Xt.observe.push({
  matches: '.opc [type="submit"]:not([data-role="opc-continue"]), form[data-role="login"] [type="submit"]',
  fnc: function (main, index, query) {

    // enable

    function enableExitIntent() {
      if (!window.exitIntentActivated) {
        window.exitIntentActivated = true;
        console.debug('Exit intent activated', window.exitIntentActivated);
      }
    }

    enableExitIntent();

    // disable

    function disableExitIntent() {
      if (window.exitIntentActivated) {
        window.exitIntentActivated = null;
        console.debug('Exit intent deactivated', window.exitIntentActivated);
      }
    }

    // events

    console.debug('Exit intent will activate on', main);
    main.addEventListener('mousedown', disableExitIntent);
    main.addEventListener('touchstart', disableExitIntent);

  }
});
*/

//////////////////////
// xtend extension: page-loader
//////////////////////

window.pageHide = function (e) {
  let html = document.querySelector('html');
  html.classList.remove('preloaded', 'preloaded-delay');
  html.classList.add('preload-fade');
  html.dispatchEvent(new CustomEvent('preload.show.xt'));
  clearTimeout(parseFloat(html.dataset.preloadedTimeout));
  window.deactivateScrolls();
  window.dispatchEvent(new CustomEvent('autoClose.xt'));
};

window.pageShow = function (e) {
  let html = document.querySelector('html');
  html.classList.add('preloaded');
  html.dispatchEvent(new CustomEvent('preload.show.xt'));
  html.dataset.preloadedTimeout = setTimeout( function() {
    html.classList.add('preloaded-delay');
    html.dispatchEvent(new CustomEvent('preload.show.delay.xt'));
  }, 200).toString();
  window.activateScrolls();
};

// special links

Xt.observe.push({
  matches: '[href^="mailto:"], [href^="tel:"]',
  fnc: function (main, index, query) {

    main.addEventListener('click', function () {
      window.onbeforeunloadskip = true;
    })

  }
});

// beforeunload

window.onbeforeunload = function(e) {
  if (window.onbeforeunloadskip) {
    window.onbeforeunloadskip = false;
    return;
  }
  // exit intent
  if (window.exitIntentActivated) {
    let result = confirm();
    if (!result){
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    return result;
  }
};

// load

if (document.readyState !== "loading") {
  window.pageShow();
} else {
  document.addEventListener('DOMContentLoaded', window.pageShow);
}

//////////////////////
// @FIX #overlay--login
//////////////////////

Xt.observe.push({
  matches: '#overlay--login',
  fnc: function (main, index, query) {

    let trigger = document.querySelector('#overlay--login_toggle');
    if (trigger) {
      let self = Xt.init('xt-overlay', trigger, {
        "targets": "#overlay--login",
      });
    }

  }
});

//////////////////////
// slider--home
//////////////////////

Xt.observe.push({
  matches: '.slider--home',
  fnc: function (main, index, query) {

    // vars

    let timeImg = .75; // @FIX reset after off.xt
    let timeImgZoom = 10;

    // slider

    let self = Xt.init('xt-slider', main, {
      "drag": {
        "wrap": true,
        "friction": false,
        "overflow": false,
      },
      "auto": {
        "time": 6000,
      },
      "groupMq": false,
      "align": "left",
      "autoHeight": false,
    });

    // drag

    self.dragger.addEventListener('drag.xt.slider', function (e) {
      let target = self.targets.filter(x => x.classList.contains('active'))[0];
      let ratio = Math.abs(self.detail.xStart - self.detail.xCurrent) / target.clientWidth;
      let imgSize = self.dragger.offsetWidth / 6;
      // direction
      let direction = 1;
      if (self.detail.xStart - self.detail.xCurrent > 0) {
        direction = -1;
      }
      // others
      for (let tr of self.targets.filter(x => !x.classList.contains('active'))) {
        let img = tr.querySelector('.slider--home_img_inner');
        TweenMax.set(img, {x: (imgSize * direction) - (imgSize * ratio * direction), opacity: ratio + 0.5});
      }
      // img
      let img = target.querySelector('.slider--home_img_inner');
      TweenMax.set(img, {x: -imgSize * ratio * direction, opacity: 1 - ratio + 0.5});
    });

    // dragend

    self.dragger.addEventListener('dragreset.xt.slider', function (e) {
      let target = self.targets.filter(x => x.classList.contains('active'))[0];
      // img
      let img = target.querySelector('.slider--home_img_inner');
      TweenMax.to(img, timeImg, {x: 0, opacity: 1, ease: window.easeInOut});
    });

    // on

    self.object.addEventListener('on.xt', function (e) {
      let tr = e.target;
      if (self.targets.includes(tr)) { // event bubbles
        let img = tr.querySelector('.slider--home_img_inner');
        if (self.initial) {
          TweenMax.set(img, {x: 0, opacity: 1, scale: 1});
        } else {
          TweenMax.to(img, timeImg, {x: 0, opacity: 1, ease: window.easeInOut});
        }
      }
    });

    // off

    self.object.addEventListener('off.xt', function (e) {
      let tr = e.target;
      if (self.targets.includes(tr)) { // event bubbles
        let imgSize = self.dragger.offsetWidth / 6;
        // direction
        let direction = 1;
        if (tr.classList.contains('inverse')) {
          direction = -1;
        }
        // img
        let img = tr.querySelector('.slider--home_img_inner');
        TweenMax.to(img, timeImg, {x: imgSize * direction, opacity: 0.5, ease: window.easeInOut})
          .eventCallback('onComplete', function () {
            TweenMax.set(img, {x: 0, opacity: 1, scale: 1}); // @FIX reset after off.xt
          });
      }
    });

  }
});

//////////////////////
// .slider.product-items
//////////////////////

Xt.observe.push({
  matches: '.slider.product-items:not(.products-items-noslider)',
  fnc: function (main, index, query) {

    if (main.classList.contains('products-items-ajax')) {

      main.dataset.doneAjax = 'false'

      // observe

      Xt.observe.push({
        matches: '.slider.product-items.products-items-ajax .slide',
        fnc: function (main2, index, query) {

          if (main.dataset.doneAjax === 'false') {

            main.dataset.doneAjax = 'true'

            requestAnimationFrame(() => {

              console.debug('products-items-ajax initialization', main, main.querySelectorAll('.slide'))

              // slider

              let self = Xt.init('xt-slider', main, {
                "align": "left",
                "jump": false,
                "groupMq": {"all": 1},
                "loop": false,
                "contain": true,
                "autoHeight": false,
              });
              self.unmount = function () {
                self = null;
              };

              // init

              self.object.addEventListener('init.xt', function (e) {
                // fix video xt-wrap
                for(const item of main.querySelectorAll('.xt-wrap .product-item')) {
                  initializeVideo(item)
                }
                // fixInitMaskContainer
                for (let wrap of self.object.querySelectorAll('.xt-wrap')) {
                  let mask = wrap.querySelector('.mask_container');
                  if (mask) {
                    window.fixInitMaskContainer(mask);
                  }
                }
              });

            })

          }

        }

      });

    } else {

      // slider

      let self = Xt.init('xt-slider', main, {
        "align": "left",
        "jump": false,
        "groupMq": {"all": 1},
        "loop": false,
        "contain": true,
        "autoHeight": false,
      });
      self.unmount = function () {
        self = null;
      };

      // init

      self.object.addEventListener('init.xt', function (e) {
        // fix video xt-wrap
        for(const item of main.querySelectorAll('.xt-wrap .product-item')) {
          initializeVideo(item)
        }
        // fixInitMaskContainer
        for (let wrap of self.object.querySelectorAll('.xt-wrap')) {
          let mask = wrap.querySelector('.mask_container');
          if (mask) {
            window.fixInitMaskContainer(mask);
          }
        }
      });
    }

  }
});

//////////////////////
// slider--gallery
//////////////////////

Xt.observe.push({
  matches: '.slider--gallery',
  fnc: function (main, index, query) {

    // slider

    let self = Xt.init('xt-slider', main, {
      "drag": {
        "factor": 0,
      },
      "groupMq": false,
      "autoHeight": false,
      "imageLoadedInit": false,
    });

    // fix cls

    main.addEventListener('init.xt', function() {
      main.setAttribute('data-slider-inited-fix', 'true')
    });

    // hide slider_pagination if only one

    if (self.elements.length === 1) {
      const pag = self.object.querySelector('.slider_pagination_outer');
      if (pag) {
        pag.classList.add('display--none');
      }
    }

    // overlay

    if (main.classList.contains('slider--gallery--main')) {

      let overlay = document.querySelector('#overlay--gallery');
      for (let [i, target] of self.targets.entries()) {

        let item = target.querySelector('.slider--gallery_item');
        item.addEventListener('click', function() {
          for (let slide of overlay.querySelectorAll('.slide.active')) {
            slide.classList.remove('active');
          }
          overlay.querySelectorAll('.slide')[i].classList.add('active');
          overlay.dispatchEvent(new CustomEvent('on.xt'));
          // xt-slider
          let self = Xt.get('xt-slider', overlay.querySelector('.slider--gallery'));
          if (self) {
            self.init();
          }
        });

      }
    }

  }
});

//////////////////////
// replace templates/block-loader.html
// @FIX magento loader
//////////////////////

Xt.observe.push({
  matches: '.loading-mask',
  fnc: function (main, index, query) {

    if (!main.dataset.loaderDone) {
      main.dataset.loaderDone = 'true';
      if (main.closest('.main-container')) {
        main.innerHTML = '\n' +
          '<div class="loader loader--x loader--size-x loader--background">\n' +
          '    <div class="filler">\n' +
          '        <span></span><span></span>\n' +
          '    </div>\n' +
          '</div>';
      } else {
        main.innerHTML = '\n' +
          '<div class="loader loader--x loader--size-top loader--background">\n' +
          '    <div class="filler">\n' +
          '        <span></span><span></span>\n' +
          '    </div>\n' +
          '</div>';
      }
    }

  }
});

//////////////////////
// populateQty
//////////////////////

Xt.observe.push({
  matches: 'input.qty, input.item-qty',
  fnc: function (main, index, query) {

    let el = main;

    if (!el.dataset.populateQtyDone) {
      el.dataset.populateQtyDone = 'true';
      // populate
      let control = el.parentNode;
      let html = control.innerHTML;
      control.classList.add('group');
      control.classList.add('group-number');
      control.classList.add('group-number-line');
      control.innerHTML = '<span class="group-inner">' +
        '<button type="button" class="btn group-number-remove"><span>-</span></button>' +
        '</span>';
      control.innerHTML += html;
      control.innerHTML += '<span class="group-inner">' +
        '<button type="button" class="btn group-number-add"><span>+</span></button>' +
        '</span>';
      // magento
      if (el.getAttribute('data-validate')) {
        let error = false;
        try {
          JSON.parse(el.getAttribute('data-validate'));
        } catch (e) {
          error = true;
        }
        if (!error) {
          let options = JSON.parse(el.getAttribute('data-validate'));
          let input = control.querySelectorAll('input')[0];
          let min = options['validate-item-quantity']['minAllowed'];
          let max = options['validate-item-quantity']['maxAllowed'];
          let step = options['validate-item-quantity']['qtyIncrements'];
          if (min) {
            input.setAttribute('min', min);
          }
          if (max) {
            input.setAttribute('max', max);
          }
          if (step) {
            input.setAttribute('step', step);
          }
        }
      }
    }

  }
});

//////////////////////
// xtend extension: group-number
//////////////////////

function inputNumberChange(step, e) {
  if (!e || !e.detail || !e.detail.skip) {
    let main = this;
    let input = main.querySelectorAll('input')[0];
    let val = parseFloat(input.value);
    val = val + step;
    inputNumberValidate.bind(main)(val);
  }
}

function inputNumberValidate(val) {
  let main = this;
  let input = main.querySelectorAll('input')[0];
  let addEl = main.querySelectorAll('.group-number-add')[0];
  let removeEl = main.querySelectorAll('.group-number-remove')[0];
  // disabled
  addEl.removeAttribute('disabled');
  removeEl.removeAttribute('disabled');
  // check min and max
  let inputMin = parseFloat(input.getAttribute('min')) || 1;
  let inputMax = parseFloat(input.getAttribute('max')) || Infinity;
  if (val <= inputMin) {
    val = inputMin;
    removeEl.setAttribute('disabled', 'disabled');
  }
  if (val >= inputMax) {
    val = inputMax;
    addEl.setAttribute('disabled', 'disabled');
  }
  // set value
  input.value = val;
  input.dispatchEvent(new CustomEvent('change', {bubbles: true, detail: {skip: true}}));
}

Xt.observe.push({
  matches: '.group-number',
  fnc: function (main, index, query) {

    // init
    inputNumberChange.bind(main, 0)();
    // vars
    let inputEl = main.querySelectorAll('input')[0];
    let step = parseFloat(inputEl.getAttribute('step')) || 1;
    // add
    let addEl = main.querySelectorAll('.group-number-add')[0];
    let addStep = step;
    let addHandler = Xt.dataStorage.get(addEl, 'addHandler');
    addHandler = addHandler ? addHandler : Xt.dataStorage.set(addEl, 'addHandler', inputNumberChange.bind(main, addStep));
    addEl.removeEventListener('click', addHandler);
    addEl.addEventListener('click', addHandler);
    // remove
    let removeEl = main.querySelectorAll('.group-number-remove')[0];
    let removeStep = -step;
    let removeHandler = Xt.dataStorage.get(removeEl, 'removeHandler');
    removeHandler = removeHandler ? removeHandler : Xt.dataStorage.set(removeEl, 'removeHandler', inputNumberChange.bind(main, removeStep));
    removeEl.removeEventListener('click', removeHandler);
    removeEl.addEventListener('click', removeHandler);
    // change
    let inputHandler = Xt.dataStorage.get(inputEl, 'inputHandler');
    inputHandler = inputHandler ? inputHandler : Xt.dataStorage.set(inputEl, 'inputHandler', inputNumberChange.bind(main, 0));
    inputEl.removeEventListener('change', inputHandler);
    inputEl.addEventListener('change', inputHandler);

  }
});

//////////////////////
// xtend extension: multilevel
//////////////////////

(function () {

  let main = document.querySelector('.multilevel');
  if (main) {
    let btns = main.querySelectorAll('.multilevel-reset');
    for (let btn of btns) {
      btn.addEventListener('click', function (e) {
        const reset = btn.getAttribute('data-xt-reset')
        if (reset && reset !== '') {
          const resetEl = main.querySelector('[data-xt-group="' + reset + '"]')
          if (resetEl) {
            resetEl.dispatchEvent(new CustomEvent('on.xt'));
            return
          }
        }
        main.querySelector('#multilevel-tab-reset').dispatchEvent(new CustomEvent('on.xt'));
      });
    }
  }

})();

//////////////////////
// distributors
//////////////////////

if (window.distributorsJson) {
  let container = document.querySelector('.distributors');
  let intro = container.querySelector('.distributors_intro');
  let body = container.querySelector('.distributors_body');
  let noitems = container.querySelector('.distributors_noitems');
  let json = JSON.parse(JSON.stringify(window.distributorsJson));
  // groups
  let groups = json.distributors.groups;
  let firstlevel = container.querySelector('.distributors-firstlevel');
  let firstlevelSubmenu = firstlevel.closest('.page-submenu');
  const groupsNotEmpty = groups.filter(x => json.distributors.items.filter(y => y.group.split(',').includes(x)).length)
  for (let group of groupsNotEmpty) {
    let separator = group.split(':');
    if (separator.length === 1) {
      firstlevel.append(Xt.createElement('<button type="button" class="btn btn--menu" data-group="' + group + '"><span>' + group + '</span></a>'));
    } else {
      let parent = separator[0];
      let child = separator[1];
      if (!document.querySelector('#child--' + parent)) {
        firstlevelSubmenu.append(Xt.createElement('\n' +
          '            <div class="submenu_wrapper">\n' +
          '                <div class="submenu" id="child--' + parent + '">\n' +
          '                    <div class="submenu_inner">\n' +
          '                        <div class="container fluid">\n' +
          '                            <div class="submenu_category">\n' +
          '                            </div>\n' +
          '                        </div>\n' +
          '                        <div class="header_background submenu_background"></div>\n' +
          '                    </div>\n' +
          '                </div>\n' +
          '            </div>'));
        firstlevel.append(Xt.createElement('\n' +
          '        <button type="button" class="btn btn--menu caret btn_linked--container" id="parent--' + parent + '"\n' +
          '           data-xt-toggle=\'{"targets": "#child--' + parent + '", "closeOutside": "body"}\'>\n' +
          '            <span class="btn_linked--container--replace">' + parent + '</span>\n' +
          '        </button>'));
      }
      document.querySelector('#child--' + parent + ' .submenu_category').append(Xt.createElement('\n' +
        '                        <button type="button" class="btn btn--menu" data-group="' + group + '" data-group-parent="' + parent + '">\n' +
        '                            <span>' + child + '</span>\n' +
        '                        </button>'));
    }
  }
  // items
  let items = json.distributors.items;
  for (let item of items) {
    let clone = Xt.createElement('\n' +
      '                <div class="distributor_item_col" data-item-group="' + item.group + '">\n' +
      '                    <div class="distributor_item">\n' +
      '                        <div class="distributor_item_inner">\n' +
      '                            <div class="badge_container">\n' +
      '                            </div>\n' +
      '                            <div class="distributor_item_title">\n' +
      '                            </div>\n' +
      '                            <div class="distributor_item_content">\n' +
      '                            </div>\n' +
      '                        </div>\n' +
      '                    </div>\n' +
      '                </div>');
    let title = clone.querySelector('.distributor_item_title');
    let content = clone.querySelector('.distributor_item_content');
    let badge = clone.querySelector('.badge_container');
    if (item.title) {
      title.innerHTML += item.title + '<br/>';
    }
    if (item.address) {
      content.innerHTML  += item.address + '<br/>';
    }
    if (item.referent) {
      content.innerHTML  += item.referent + '<br/>';
    }
    if (item.email) {
      content.innerHTML += '<a href="mailto:' + item.email + '">' + item.email + '</a><br/>';
    }
    if (item.telephone) {
      let telephones = item.telephone.split(', ')
      for (let telephone of telephones) {
        content.innerHTML += '<a href="tel:' + telephone.replace(/\s/g, '') + '">' + telephone + '</a><br/>';
      }
    }
    if (item.tags) {
      for (let tag of item.tags) {
        badge.append(Xt.createElement('<div class="badge badge--red"><span>' + tag + '</span></div>'));
      }
    }
    body.querySelector('.row').append(clone);
  }
  // activateGroup
  let activateGroup = function (btn) {
    let g = btn.getAttribute('data-group');
    window.location.hash = g;
    intro.classList.add('display--none');
    body.classList.remove('display--none');
    let found = 0;
    let items = container.querySelectorAll('[data-item-group]');
    for (let item of items) {
      let groups = item.getAttribute('data-item-group').split(',');
      if (groups.includes(g)) {
        item.classList.remove('display--none');
        found++;
      } else {
        item.classList.add('display--none');
      }
    }
    if (found === 0) {
      noitems.classList.remove('display--none');
    } else {
      noitems.classList.add('display--none');
    }
  };
  let btns = container.querySelectorAll('[data-group]');
  for (let btn of btns) {
    btn.addEventListener('click', function() {
      activateGroup(btn);
    });
  }
  // hash
  let onHashChange = function(initial) {
    if (window.location.hash) {
      let g = decodeURI(window.location.hash.split('#')[1]);
      let btn = document.querySelector('[data-group="' + g + '"]');
      if (btn) {
        if (initial) {
          btn.classList.add('current', 'active');
          let parent = btn.getAttribute('data-group-parent');
          if (parent) {
            // click after xt-toggle is inited
            let p = container.querySelector('#parent--' + parent);
            p.addEventListener('init.xt', function() {
              btn.dispatchEvent(new CustomEvent('click'));
            });
          }
        } else {
          btn.dispatchEvent(new CustomEvent('on.xt'));
          btn.dispatchEvent(new CustomEvent('click'));
        }
      }
    }
  };
  window.onpopstate = function(event) {
    onHashChange();
  };
  onHashChange(true);
}

//////////////////////
// xtend extension: btn_linked
//////////////////////

(function () {

  let shares = document.querySelectorAll('.btn_linked')
  if (shares) {
    for (let share of shares) {
      let btns = share.querySelectorAll('.btn:not(.btn_linked--exclude), :scope > ul > li'); // @FIX ul for magento lists
      for (let btn of btns) {

        // events

        let eventOn = function (e) {
          if (!btn.classList.contains('btn_linked--container')) { // not on container
            // activation
            for (let b of btns) {
              b.classList.remove('active', 'current');
            }
            btn.classList.add('active', 'current');
            // activation btn_linked_toggle
            if (share.classList.contains('btn_linked_toggle')) {
              for (let b of btns) {
                b.classList.remove('initial-share');
              }
              btn.classList.add('initial-share');
            }
            // containers replace
            let containers = Array.from(btns).filter(x => x.classList.contains('btn_linked--container'));
            for (let container of containers) {
              let replace = container.querySelector('.btn_linked--container--replace');
              if (replace) {
                let replaceInitial = replace.getAttribute('data-replace-initial');
                if (replaceInitial) {
                  replace.innerHTML = replaceInitial;
                  container.removeAttribute('data-replace-initial');
                }
              }
            }
          }
          // containers
          let target = btn.closest('[aria-labelledby]');
          if (target) {
            let aria = target.getAttribute('aria-labelledby');
            if (aria) {
              let ids = aria.split(' ');
              for (let id of ids) {
                let container = document.querySelector('#' + id);
                // close container
                container.dispatchEvent(new CustomEvent('off.xt'));
                // container activation
                if (!btn.classList.contains('btn_linked--container')) {
                  for (let b of btns) {
                    b.classList.remove('active', 'current');
                  }
                  container.classList.add('active', 'current');
                  container.dispatchEvent(new CustomEvent('mouseenter'));
                }
                // populate text
                let replace = container.querySelector('.btn_linked--container--replace');
                if (replace) {
                  replace.setAttribute('data-replace-initial', replace.innerHTML);
                  replace.innerHTML = btn.innerText;
                }
              }
            }
          }
        };

        let eventOff = function (e) {
          if (e.target === btn) { // @FIX event.xt: handler triggered by child xt events
            btn.classList.remove('active', 'current');
            let actives = Array.from(btns).filter(x => x.classList.contains('active'));
            if (actives.length) {
              // if activated another one dont reset
              return
            }
            let initials = Array.from(btns).filter(x => x.classList.contains('initial-share'));
            if (initials.length) {
              let target = initials[0].closest('[aria-labelledby]');
              if (target) {
                let aria = target.getAttribute('aria-labelledby');
                if (aria) {
                  let ids = aria.split(' ');
                  for (let id of ids) {
                    let container = document.querySelector('#' + id);
                    container.classList.add('active', 'current');
                    container.dispatchEvent(new CustomEvent('mouseenter'));
                  }
                }
              } else {
                initials[0].classList.add('active', 'current');
                initials[0].dispatchEvent(new CustomEvent('mouseenter'));
              }
            } else {
              for (let b of btns) {
                b.classList.remove('share--this', 'share--other');
              }
            }
          }
        };

        let eventEnter = function (e) {
          if (e.target === btn) { // @FIX event.xt: handler triggered by child xt events
            for (let b of btns) {
              b.classList.add('share--other');
              b.classList.remove('share--this');
            }
            btn.classList.remove('share--other');
            btn.classList.add('share--this');
            // activate drop btn if inside drop
            let drop = btn.closest('.drop_outer');
            if (drop) {
              let dropBtn = drop.querySelector(':scope > a, :scope > button');
              dropBtn.classList.remove('share--other');
              dropBtn.classList.add('share--this');
            }
          }
        };

        let eventLeave = function (e) {
          if (e.target === btn) { // @FIX event.xt: handler triggered by child xt events
            let actives = Array.from(btns).filter(x => x.classList.contains('active'));
            let currents = Array.from(btns).filter(x => x.classList.contains('current'));
            if (currents.length) {
              currents[0].dispatchEvent(new CustomEvent('mouseenter'));
            } else if (actives.length) {
              actives[0].dispatchEvent(new CustomEvent('mouseenter'));
            } else {
              for (let b of btns) {
                b.classList.remove('share--this', 'share--other');
              }
            }
          }
        };

        // events

        btn.addEventListener('mouseenter', eventEnter);
        btn.addEventListener('mouseleave', eventLeave);
        btn.addEventListener('click', eventOn);

        btn.addEventListener('on.xt', eventEnter);
        btn.addEventListener('off.xt', eventOff);

        // init

        if (btn.classList.contains('current')) {
          btn.classList.add('initial-share');
          btn.dispatchEvent(new CustomEvent('on.xt'));
        }

        if (btn.classList.contains('active')) {
          btn.dispatchEvent(new CustomEvent('click'));
        }

      }
    }
  }

})();

//////////////////////
// .btn--menu
//////////////////////

(function () {

  let header = document.querySelector('.header:not(.xt-clone)');
  let backdrop = document.querySelector('.backdrop--header')
  if (header) {
    let headerBlock = 0;
    let btns = header.querySelectorAll('.btn--menu:not(.btn_linked--exclude)');
    for (let btn of btns) {

      // on

      let eventOn = function (e) {
        if (e.target === btn) {
          headerBlock++;
          header.classList.add('white');
          backdrop.classList.add('active');
        }
      };

      // off

      let eventOff = function (e) {
        if (e.target === btn) {
          headerBlock--;
          if (headerBlock <= 0) {
            headerBlock = 0;
            header.classList.remove('white');
            backdrop.classList.remove('active');
          }
        }
      };

      // events

      btn.addEventListener('on.xt', eventOn);
      btn.addEventListener('off.xt', eventOff);

    }
  }

})();

/**
 * Merge objects
 * @param {Array} arr Array of objects to merge
 * @returns {Object} Merged object
 */
Xt.mergeFix = function (arr) {
  const final = {}
  for (const obj of arr) {
    if (obj) {
      for (const [key, value] of Object.entries(obj)) {
        if (value !== null && typeof value === 'object' &&
          !Array.isArray(value) && // not array
          !value.nodeName && // not HTML element
          value !== window) { // not window
          final[key] = Xt.merge([final[key], value])
        } else {
          final[key] = value
        }
      }
    }
  }
  return final
}

/**
 * xtend extension: googlelocator
 */

 Xt.observe.push({
  matches: 'body',
  fnc: function (main, index, query) {

window.initGooglelocator = function () {
    // init

    const object = document.querySelector('.googlelocator')
    const self = new Xt.Googlelocator(object, {
      locate: false,
      initialSearch: true,
      markers: window.markers,
      map: {
        cluster: {
          minimumClusterSize: 5,
          imagePath: '/assets/shop/assets/images/googlemaps/m'
        },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
      },
      formatData: {
        info: function(self, location, el) {
          return false
        },
        sort: function(self, locations) {
          if (self.searchInput.value === '') {
            locations.sort((a, b) => {
              if (a.marker.name > b.marker.name) {
                return 1;
              }
              if (b.marker.name > a.marker.name) {
                return -1;
              }
              return 0;
            })
          } else {
            locations.sort((a, b) => a.distance - b.distance)
          }
        },
        img: function(self, location, el) {
          let str = location.marker.photo
          if (!str || str === '') {
            el.remove()
          } else {
            el.setAttribute('src', str)
          }
        },
        address: function(self, location, el) {
          let str = ''
          str += location.marker.address
          if (!str || str === '') {
            el.remove()
          } else {
            el.innerHTML = str
          }
        },
        additional: function(self, location, el) {
          let str = ''
          if (location.marker.email || location.marker.whatsApp || location.marker.telephone) {
            str += '<div class="googlelocator_item_title">' + object.getAttribute('data-contacts') + '</div>'
            str += '<p>'
            if (location.marker.telephone) {
              str += object.getAttribute('data-phone') + ' '
              str += '<a href="tel:' + location.marker.telephone + '">' + location.marker.telephone + '</a><br/>'
            }
            if (location.marker.whatsApp) {
              str += object.getAttribute('data-whatsapp') + ' '
              str += '<a href="https://wa.me/' + location.marker.whatsApp + '">' + location.marker.whatsApp + '</a><br/>'
            }
            if (location.marker.email) {
              str += object.getAttribute('data-email') + ' '
              str += '<a href="mailto:' + location.marker.email + '">' + location.marker.email + '</a><br/>'
            }
            str += '</p>'
          }
          if (location.marker.openingHours) {
            str += '<div class="googlelocator_item_title">' + object.getAttribute('data-hours') + '</div>'
            str += '<p>'
            location.marker.openingHours.forEach((elem) => {
              str += elem + '<br/>'
            })
            str += '</p>'
          }
          if (!str || str === '') {
            el.remove()
          } else {
            el.innerHTML = str
          }
        },
        direction: function(self, location, el) {
          let str = 'https://www.google.com/maps/dir/?api=1&destination='
          str += location.marker.name
          str += '+' + location.marker.address
          el.setAttribute('href', encodeURI(str))
        },
        url: function(self, location, el) {
          el.setAttribute('href', encodeURI(location.marker.url))
        },
      },
    })

    // .btn--more-info

    self.object.addEventListener('change.xt.googlelocator', function (e) {
      const btns = self.itemsContainer.querySelectorAll('.btn--more-info')
      for (const btn of btns) {
        btn.addEventListener('click', function() {
          const container = btn.closest('.googlelocator_item')
          container.classList.add('active')
        });
      }
      const closes = self.itemsContainer.querySelectorAll('.btn--close')
      for (const close of closes) {
        close.addEventListener('click', function() {
          const container = close.closest('.googlelocator_item')
          container.classList.remove('active')
        });
      }
    })

}

if (window.initedGooglelocator) {
  window.initGooglelocator()
}

  }
})

//////////////////////
// export
//////////////////////

typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = Xt :
  typeof define === 'function' && define.amd ? define(Xt) :
    global.Xt = Xt;
